import React, { useEffect, useState } from "react";
import { Close } from "@material-ui/icons";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Box,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { badgesAnimations } from "./constant";
import { get } from "lodash";

const BadgeRecievedAnimation = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { badgeDetail } = props;
  const [displayBadge, setDisplayBadge] = useState(badgesAnimations[0]);
  useEffect(() => {
    const badgeGif = badgesAnimations.find(res => res.type === badgeDetail);
    setDisplayBadge(badgeGif);
  }, [badgeDetail]);
  const handleClose = () => {
    props.setOpen(false);
  };
  useEffect(() => {
    if (props.open) {
      setTimeout(function () {
        props.setOpen(false);
      }, 5000);
    }
  }, [props.open]);
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.modalDialog}
      >
        <Button onClick={handleClose} className={classes.closeModal}>
          <Close fontSize="large" />
        </Button>
        <DialogContent className={classes.modalContent}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            className={classes.badgeModal}

          >
            <Typography variant="h4" className="mb-3">
              {t("animation.congratulations")}
            </Typography>
            <Typography variant="body2" className="f-gray">
              {t("animation.targetMessage")}
            </Typography>
            <img
              src={get(displayBadge, "gifToDisplay", "")}
              alt="Gif animation"
            />
            <Typography variant="h6">
              {get(displayBadge, "badgeName", "")}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default BadgeRecievedAnimation;
